// @flow
export const PETS_INCLUDED_LEGACY_KEY = {
    abritel: 'SpecialOptions:suitability_pets_considered',
    homeaway_us: 'amenities_title:suitability_pets_considered',
    homeaway_uk: 'amenities_title_old:suitability_pets_considered',
    homelidays_es: 'suitability_title:suitability_pets_considered',
    homelidays_fr: 'suitability_title:suitability_pets_considered',
    homelidays_it: 'suitability_title:suitability_pets_considered',
    vrbo: 'amenities_title:suitability_pet_friendly'
};

const PETS_INCLUDED_LEGACY_LINK = {
    abritel: 'Options spéciales:animaux acceptes',
    homeaway_at: 'Ausstattung:Haustiere erlaubt',
    homeaway_de: 'Ausstattung:Haustiere erlaubt',
    homeaway_es: 'Servicios:se admiten mascotas',
    homeaway_gr: 'Χαρακτηριστικά:δέχεται κατοικίδια',
    homeaway_pl: 'Cechy:Przyjazne dla zwierząt',
    homeaway_uk: 'Property Details:pets considered',
    homeaway_us: 'Features:pets considered',
    homelidays_es: 'Opciones especiales:admiten-animales',
    homelidays_fr: 'Options spéciales:animaux-acceptes',
    homelidays_it: 'Caratteristiche speciali:animali-ammessi',
    vrbo: 'Features:pet_friendly'
};

export const PETS_INCLUDED_ID = 'filter:27';

// $FlowFixMe
export const PETS_INCLUDED_IDS: string[] = [
    ...Object.values(PETS_INCLUDED_LEGACY_KEY),
    ...Object.values(PETS_INCLUDED_LEGACY_LINK),
    PETS_INCLUDED_ID
];

export const getLegacyPetFilterName = (siteName: string) => {
    return (
        PETS_INCLUDED_LEGACY_KEY[siteName.toLowerCase()] ||
        PETS_INCLUDED_LEGACY_KEY.homeaway_us
    );
};

export const isPetFilter = (filter: string) =>
    PETS_INCLUDED_IDS.map((id) => id.toLowerCase()).includes(
        decodeURIComponent(filter).toLowerCase()
    );

/**
 * Syncs the pets refinement filter with the trip data pets flag
 * @param {SearchRequest} searchRequest
 * @param {string} siteName
 * @param {boolean} includePets
 */
export const syncPets = (searchRequest: any) => {
    const newRequest = Object.assign({}, searchRequest);

    newRequest.filter = []
        .concat(newRequest.filter || [])
        .filter((f) => !isPetFilter(f));

    if (newRequest.petIncluded) {
        newRequest.filter = newRequest.filter.concat([PETS_INCLUDED_ID]);
    }
    return newRequest;
};

export const petsInFilters = (filters: Array<string> = []): boolean => {
    return !![].concat(filters).find(isPetFilter);
};
